import { render, staticRenderFns } from "./LeftAdministracao.vue?vue&type=template&id=601d589d&scoped=true"
import script from "./LeftAdministracao.vue?vue&type=script&lang=js"
export * from "./LeftAdministracao.vue?vue&type=script&lang=js"
import style0 from "./LeftAdministracao.vue?vue&type=style&index=0&id=601d589d&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601d589d",
  null
  
)

export default component.exports